/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LastCourseType model module.
 * @module model/LastCourseType
 * @version 1.0.0
 */
class LastCourseType {
    /**
     * Constructs a new <code>LastCourseType</code>.
     * Student last course type options
     * @alias module:model/LastCourseType
     */
    constructor() { 
        
        LastCourseType.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LastCourseType</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LastCourseType} obj Optional instance to populate.
     * @return {module:model/LastCourseType} The populated <code>LastCourseType</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LastCourseType();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
LastCourseType.prototype['id'] = undefined;

/**
 * @member {String} name
 */
LastCourseType.prototype['name'] = undefined;






export default LastCourseType;

